import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { delayedFadeIn } from "../animation/fade";

export const Menu = styled.div<{
  veryCondensed?: boolean;
  condensed?: boolean;
  open?: boolean;
}>`
  display: flex;
  justify-content: space-around;
  min-width: ${({ condensed, veryCondensed }) => {
    if (veryCondensed) {
      return "40%";
    }
    return condensed ? "70%" : "85%";
  }};
  max-width: 85%;
  align-items: center;

  ${({ open, veryCondensed }) =>
    open
      ? css`
          animation: ${delayedFadeIn} 1.5s;
          z-index: 12;
          flex-direction: column;
          align-items: flex-end;
          position: fixed;
          justify-content: flex-start;
          right: 20px;
          top: 80px;
          padding-right: 2%;
          /* This is to prevent the menu from overflowing the viewport. */
          height: ${!veryCondensed && "90vh"};
          overflow: scroll;

          a,
          select,
          * {
            font-size: 18pt;
            margin-bottom: 20px;
            @media all and (max-height: 700px) {
              font-size: 18px;
              margin-bottom: 17px;
            }

            @media all and (max-height: 600px) {
              margin-bottom: 13px;
            }
          }
          .button {
            padding: 10px 20px;
          }
          a:last-child {
            margin-bottom: 25px;
          }
          a:first-child {
            margin-top: 5px;
          }
        `
      : css`
          @media all and (max-width: 1099px) {
            display: none;
          }
        `}
`;
